var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text-center"},[_c('h3',{staticClass:"mb-4"},[_vm._v("¿Está seguro de realizar esta acción?")]),_c('TextButton',{attrs:{"disabled":_vm.loading,"loading":_vm.loading},on:{"click":_vm.confirmCancel}},[_vm._v(" Sí, continuar ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }